import { deleteAPI, getAPI, postAPI, putAPI } from '../utils/api';
import endpoints from '../utils/endpoints';

const normalizeAdminUsersResponse = (response) => {
  const body = response?.data ?? response;

  const users =
    (Array.isArray(body) && body) ||
    (Array.isArray(body?.data) && body.data) ||
    body?.data?.users ||
    body?.users ||
    body?.admins ||
    [];

  return {
    ...response,
    data: {
      ...(typeof body === 'object' && !Array.isArray(body) ? body : {}),
      data: {
        users: Array.isArray(users) ? users : [],
      },
    },
  };
};

export const getAllAdminUsers = (payload, userId, callBack, errorCallback) => {
  return (dispatch) => {
    getAPI(
      endpoints.GET_ADMIN_USERS,
      {},
      (response) => {
        callBack(normalizeAdminUsersResponse(response));
      },
      (err) => {
        errorCallback(err);
      },
      localStorage.getItem('token')
    );
  };
};

export const userAdd = (userId, payload, callBack, errorCallback) => {
  return (dispatch) => {
    postAPI(
      endpoints.ONBOARD_BACKEND_USER,
      payload,
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      },
      localStorage.getItem('token')
    );
  };
};

export const updateUser = (userId, payload, callBack, errorCallback) => {
  return (dispatch) => {
    const targetUserId = payload?.id || userId;
    putAPI(
      `${endpoints.ONBOARD_BACKEND_USER}/${targetUserId}`,
      payload,
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      },
      localStorage.getItem('token')
    );
  };
};
export const deleteBackenUser = (userId, bannerId, callBack, errorCallback) => {
  return (dispatch) => {
    deleteAPI(
      `${endpoints.ONBOARD_BACKEND_USER}/${bannerId}`,
      {},
      (response) => {
        callBack(response);
      },
      (error) => {
        errorCallback(error);
      },
      localStorage.getItem('token')
    );
  };
};
